export default __webpack_public_path__ + "locales/vi/ChangeUserTypeDialog.json?hash=358e99a5c9c31d4f979ebe9d9bbb73d6";